import React, { useCallback, useEffect, useState } from "react";
import { Box, Button, Grid, IconButton, List, Modal, Stack, Typography } from "@mui/material";
import { BIBlue, BIYellow } from "../../../assets/helpers";
import { Close as CloseIcon } from "@mui/icons-material";
import { AddCircle as AddCircleIcon } from "@mui/icons-material";
import { Postrequestcall } from "../../../request/Postrequest";
import { FETCH_PROJECTS_FAVOURITE_IMAGES } from "../../../constant/Apipath";
import Emptydata from "../../common/Emptydata";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import { English } from "../../../constant/EnglishFallback";
import { useSelector } from "react-redux";
import Loader from "../../../common/Loader";

export default function AddPicturesModal({ 
  open, 
  onClose, 
  pictureFile, 
  setPictureList, 
  pictureList, 
  selectedFromEmpty, 
  addIconPosition, 
  loginData, 
  userID, 
  loadingImages, 
  setLoadingImages,
  setImageChooseFromModalOpen,
  setSelectedFromEmpty 
}) {
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.Montages || {};
  const {
    TEXT_ADD_PHOTOS_FROM_PROJECT = English.Montages.TEXT_ADD_PHOTOS_FROM_PROJECT,
    BUTTON_SEE_MORE = English.Montages.BUTTON_SEE_MORE,
    BUTTON_BACK = English.Montages.BUTTON_BACK,
    BUTTON_MY_PHOTOS = English.Montages.BUTTON_MY_PHOTOS,
    BUTTON_SAVED_PHOTOS = English.Montages.BUTTON_SAVED_PHOTOS,
    BUTTON_ALL = English.Montages.BUTTON_ALL,
    TEXT_PLACEHOLDER_NO_DATA = English.Montages.TEXT_PLACEHOLDER_NO_DATA,
    TEXT_ADD_PITURES_TO_PROJECTS = English.Montages.TEXT_ADD_PITURES_TO_PROJECTS
  } = LanguageData || {};

  const [selectCount, setSelectCount] = useState(0);
  const [selectedPictures, setSelectedPictures] = useState([]);
  const [step, setStep] = useState(1);
  const [selectedProjectId, setSelectedProjectId] = useState(0);
  const [projectImageData, SetprojectImageData] = useState([]);
  const [imageFilter, setImageFilter] = useState("My Photos");
  const [projectPictures, setProjectPictures] = useState([]);
  const [savedImages, setSavedImages] = useState([]);
  const [allPictures, setAllPictures] = useState([]);

  const fetchFavouriteImages = useCallback(
    async (params) => {
      setLoadingImages(true);
      const obj = {
        PageNr: 1,
        NrOfRecPerPage: 0,
        UserId: Number(userID),
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [{ createdBy: Number(userID), projectId: params }]
      };
      try {
        const add = await Postrequestcall(
          FETCH_PROJECTS_FAVOURITE_IMAGES,
          obj,
          loginData?.accessToken
        );

        let pictures = add?.data?.data?.map((item) => ({
          ...item,
          fileUrl: item.pictureUrl ?? "",
          isSelected: false,
          selectCount: 0,
          imageFrom: "Project"
        }));

        const myPhotos = projectImageData.filter(
          (obj1) => !add?.data?.data?.some((obj2) => obj1.id === obj2.projectPictureId)
        );
        setProjectPictures(myPhotos);
        setSavedImages(pictures.filter((value) => value.fileUrl !== "") ?? []);

        setAllPictures([...myPhotos, ...pictures].filter((value) => value.fileUrl !== "") ?? []);
      } catch (error) {
        console.error("fetchFavouriteImages-> Error fetching favourite images: ", error);
      } finally {
        setLoadingImages(false);
      }
    },
    [userID, selectedProjectId, loginData, projectImageData, setLoadingImages]
  );

  useEffect(() => {
    if (selectedProjectId) {
      fetchFavouriteImages(selectedProjectId);
    }
  }, [selectedProjectId, fetchFavouriteImages]);

  const toggleImageSelection = async (targetImage) => {
    let imageCount = selectCount;
    let selectedCount = targetImage.selectCount;

    const isCurrentlySelected = targetImage.isSelected;

    const newSelectedState = !isCurrentlySelected;

    if (newSelectedState) {
      imageCount++;
      selectedCount = imageCount;
      setSelectedPictures((prev) => [
        ...prev,
        { ...targetImage, isSelected: true, selectCount: imageCount }
      ]);
    } else {
      imageCount--;
      setSelectedPictures((prev) => prev.filter((pic) => pic.fileUrl !== targetImage.fileUrl));
    }

    const updateImage = (img) => {
      if (img.fileUrl === targetImage.fileUrl) {
        return {
          ...img,
          isSelected: newSelectedState,
          selectCount: newSelectedState ? selectedCount : 0
        };
      }
      if (img.isSelected && img.selectCount > selectedCount && !newSelectedState) {
        return { ...img, selectCount: img.selectCount - 1 };
      }
      return img;
    };

    setPictureList((prev) => prev.map((img) => updateImage(img)));
    setSavedImages((prev) => prev.map(updateImage));
    setProjectPictures((prev) => prev.map(updateImage));
    setAllPictures((prev) => prev.map(updateImage));

    pictureFile.forEach((project) => {
      project.file = project.file.map(updateImage);
    });

    setSelectCount(imageCount);
  };

  const onFilterImageSelect = (item) => {
    toggleImageSelection(item);
  };

  const onImageSelect = (item) => {
    toggleImageSelection(item);
  };

  const handleAddPictures = () => {
    setSelectedFromEmpty(true);
    let updatedPictureList = [...pictureList];
    selectedPictures.forEach((item) => {
      let newItem = { ...item, isSelected: false, selectCount: 0 };
      updatedPictureList.splice(
        selectedFromEmpty ? pictureList.length : addIconPosition + 1,
        0,
        newItem
      );
    });
    setPictureList(updatedPictureList);
    setSelectedPictures([]);
    setSelectCount(0);
    setAllPictures((prev) => prev.map((pic) => ({ ...pic, isSelected: false, selectCount: 0 })));
    setProjectPictures((prev) =>
      prev.map((pic) => ({ ...pic, isSelected: false, selectCount: 0 }))
    );
    setSavedImages((prev) => prev.map((pic) => ({ ...pic, isSelected: false, selectCount: 0 })));
    setStep(1);
    onClose();
    setImageChooseFromModalOpen(false);
  };

  const handleSeeMoreClick = (item, data) => {
    SetprojectImageData(item);
    const projectId = data?.projectId ?? 0;
    setSelectedProjectId(projectId);
    setStep(2);
    setImageFilter("All");
  };

  const handleClose = () => {
    if (!loadingImages) {
      setSelectedPictures([]);
      setStep(1);
      setSelectCount(0);
      setImageFilter("My Photos");
      onClose();
    }
  };

  const filterImages = (images) => {
    if (imageFilter === "My Photos") {
      return images.filter((op) => op.imageFrom === "Project");
    } else if (imageFilter === "Saved Photos") {
      return images.filter((op) => op.fileUrl !== "");
    }
    return images;
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6"> {TEXT_ADD_PHOTOS_FROM_PROJECT} </Typography>
          <Stack direction={"row"}>
            {pictureFile?.length > 0 && (
              <IconButton color="primary" onClick={handleAddPictures}>
                <AddCircleIcon style={{ color: BIBlue }} />
              </IconButton>
            )}
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </Box>

        <Box
          className="main-content-card-list"
          sx={{
            height: "500px",
            justifyContent: pictureFile?.length > 0 ? "flex-start" : "center"
          }}>
          {loadingImages ? (
            <Loader />
          ) : (
            <>
              {!loadingImages &&
                step === 1 &&
                (pictureFile?.length > 0 ? (
                  <List disablePadding>
                    {pictureFile?.map((item, index) => (
                      <Stack key={index} spacing={1}>
                        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                          {item?.projectName}
                        </Typography>
                        <Grid container spacing={1} columns={{ xs: 12, md: 12 }}>
                          {filterImages(
                            item?.file
                              ?.filter((op) => op?.thumbImageUrl && op?.thumbImageUrl !== "")
                              ?.slice(0, 3)
                          )?.map((op, index) => (
                            <Grid
                              key={index}
                              size={{ xs: 4, md: 4 }}
                              sx={{ height: { xs: 90, md: 160 } }}>
                              <img
                                key={index}
                                src={op?.thumbImageUrl}
                                onClick={() => onImageSelect(op, index, op.projectId)}
                                alt="Montage"
                                style={{
                                  cursor: "pointer",
                                  height: "100%",
                                  width: "100%",
                                  objectFit: "cover",
                                  border: `5px solid ${op?.isSelected ? BIYellow : "white"}`
                                }}
                              />
                            </Grid>
                          ))}
                        </Grid>
                        <Box sx={{ justifyContent: "flex-end",  display: "flex" }} >
                          {item.file.filter((op) => op?.thumbImageUrl && op?.thumbImageUrl !== "")
                            .length > 3 && (
                            <Button
                              variant="contained"
                              onClick={() => handleSeeMoreClick(item.file, item)}>
                              {BUTTON_SEE_MORE}
                            </Button>
                          )}
                        </Box>
                      </Stack>
                    ))}
                  </List>
                ) : (
                  <Emptydata
                    icon={<PlayCircleIcon className="emptydata-icon" color={BIBlue} />}
                    firstText={TEXT_ADD_PITURES_TO_PROJECTS}
                  />
                ))}

              {!loadingImages && step === 2 && (
                <>
                  <Box sx={{ pb: 1.5,  display: "flex", justifyContent: "space-between" }} >
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        setStep(1);
                        setImageFilter("All");
                      }}>
                      {BUTTON_BACK}
                    </Button>
                    <Stack spacing={1} direction={"row"}>
                      <Button
                        variant={imageFilter === "My Photos" ? "contained" : "outlined"}
                        color="primary"
                        onClick={() => setImageFilter("My Photos")}
                        style={imageFilter === "My Photos" ? { backgroundColor: BIBlue } : {}}>
                        {BUTTON_MY_PHOTOS}
                      </Button>
                      <Button
                        variant={imageFilter === "Saved Photos" ? "contained" : "outlined"}
                        color="primary"
                        onClick={() => setImageFilter("Saved Photos")}
                        style={imageFilter === "Saved Photos" ? { backgroundColor: BIBlue } : {}}>
                        {BUTTON_SAVED_PHOTOS}
                      </Button>
                      <Button
                        variant={imageFilter === "All" ? "contained" : "outlined"}
                        color="primary"
                        onClick={() => setImageFilter("All")}
                        sx={{ marginRight: "10px" }}
                        style={imageFilter === "All" ? { backgroundColor: BIBlue } : {}}>
                        {BUTTON_ALL}
                      </Button>
                    </Stack>
                  </Box>
                  <Box sx={{ height: 460, overflow: "auto", scrollbarWidth: "none" }}>
                    {filterImages(
                      imageFilter === "Saved Photos"
                        ? savedImages
                        : imageFilter === "My Photos"
                          ? projectPictures
                          : allPictures
                    )?.length > 0 ? (
                      <Grid container spacing={1} columns={{ xs: 12, md: 12 }}>
                        {filterImages(
                          imageFilter === "Saved Photos"
                            ? savedImages
                            : imageFilter === "My Photos"
                              ? projectPictures
                              : allPictures
                        )?.map((op, index) => (
                          <Grid
                            key={index}
                            size={{ xs: 4, md: 4 }}
                            sx={{ height: { xs: 90, md: 160 } }}>
                            <img
                              key={index}
                              src={op?.thumbImageUrl}
                              onClick={() => onFilterImageSelect(op, index, op.projectId)}
                              alt="Montage"
                              style={{
                                cursor: "pointer",
                                height: "100%",
                                width: "100%",
                                objectFit: "cover",
                                border: `5px solid ${op?.isSelected ? BIYellow : "white"}`
                              }}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    ) : (
                      <Box
                        sx={{ alignItems: "center",  justifyContent: "center",  display: "flex" }}
                        
                        
                        height={"100%"}>
                        <Emptydata
                          icon={<PlayCircleIcon className="emptydata-icon" color={BIBlue} />}
                          firstText={TEXT_PLACEHOLDER_NO_DATA}
                        />
                      </Box>
                    )}
                  </Box>
                </>
              )}
            </>
          )}
        </Box>
      </Box>
    </Modal>
  );
}
